import {
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import "./Tariff-popup.scss";
import { Helper } from "../../../utils/Helpers";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery, useTheme } from "@mui/material";
const { getGradientTextStyle, roundOff } = new Helper();

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F9F1DD",
    color: "#252525",
    fontWeight: 500,
    [theme.breakpoints.up("md")]: {
      fontSize: "0.97vw",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.44vw",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "1.026vw 2.051vw",
      fontSize: "2.397vw",
    },
  },
  [`&.${tableCellClasses.body}`]: {
    [theme.breakpoints.up("md")]: {
      fontSize: "0.83vw",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.44vw",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.054vw",
      padding: "1.026vw 2.051vw",
    },
    fontWeight: 400,
  },
}));

const CollapsedTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F9F1DD",
    color: "#252525",
    fontWeight: 500,
    [theme.breakpoints.up("md")]: {
      fontSize: "0.97vw",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.44vw",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.397vw",
    },
  },
  [`&.${tableCellClasses.body}`]: {
    [theme.breakpoints.up("md")]: {
      fontSize: "0.83vw",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1.44vw",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.054vw",
      padding: "4px",
    },
    fontWeight: 400,
  },
  border: "0 !important",
}));


const tableHeaders = [
  { label: "Serial Number", align: "center" },
  { label: "Room Number", align: "center" },
  { label: "Room Type", align: "center" },
  // TODO: RATE_PLAN_CHANGE - Consider adding Rate Plan Name column
  { label: "Base rent", align: "left" },
  { label: "GST", align: "left" },
  { label: "Net Rent", align: "center" },
  { label: "Stay length", align: "left" },
  { label: "Number Of Rooms", align: "left" },
  { label: "SubTotal", align: "center" },
];

const TariffPopup = ({
  tariffData,
  taxRates,
  isQuickReservation,
  anchorEl,
  setAnchorEl,
  appliedCoupon,
  couponDiscountAmount = 0,
}) => {
  const { t } = useTranslation();
  let total = 0;
  const { palette } = useTheme();
  const safeCouponDiscountAmount = Math.max(
    0,
    Number(couponDiscountAmount) || 0
  );
  const calculateTotal = (value) => {
    let newValue = roundOff(value)

    return newValue
  }

  const getTotalTaxRate = (item) => {

    return Number(item.sgst || 0) + Number(item.cgst || 0) + Number(item.igst || 0) + Number(item.vat || 0);
  };

  return (
    <Popover
      className="pop-over-container"
      id={"popId"}
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() => {
        setAnchorEl(null);
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "8px",
          border: "0.5px solid #FFC150",
          overflow: "scroll",
          maxHeight: "60vh",
        },
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              textWrap: "nowrap",
              boxShadow: {
                xs: "0px 12px 20px 20px #0000000D",
                sm: "0px 12px 40px 40px #0000000D",
              },
            }}
          >
            {tableHeaders
              .filter(
                (header) =>
                  (isQuickReservation && header.label !== "Room Number") ||
                  (!isQuickReservation && header.label !== "Number Of Rooms")
              )
              .map((header, index) => (
                <StyledTableCell key={index} align={header.align}>
                  {t(
                    `common_components.tariff_popup.${header.label
                      .toLowerCase()
                      .replace(/\s+/g, "_")}`
                  )}
                </StyledTableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tariffData?.length > 0 ? (
            tariffData?.map((row, ind) => {
              const noOfRooms = Number(row.room_count) || 1;
              const stayDays = Number(row.stayDays) || 0;
              const subTotal = Number(row.netRent) || 0;
              const netRentPerDay =
                stayDays > 0 ? subTotal / noOfRooms / stayDays : 0;
              total += subTotal;
              return (
                <Fragment key={ind}>
                  <TableRow>
                    <StyledTableCell align="center">{ind + 1}</StyledTableCell>
                    {!isQuickReservation && (
                      <StyledTableCell align="center">
                        {row.room_no || "-"}
                      </StyledTableCell>
                    )}
                    <StyledTableCell
                      align="center"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      {row.room_type_name || "-"}{" "}
                      {row.grace_hours > 0 && `(Grace: ${row.grace_hours} hrs)`}
                    </StyledTableCell>

                    <StyledTableCell align="right">
                      ₹{row?.occupancy_price || row?.reservation_price}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      ₹{Number(row.taxAmount).toFixed(2)}({getTotalTaxRate(row)}%)
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      ₹
                      {calculateTotal(netRentPerDay)}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {stayDays
                        ? t(
                          `common_components.tariff_popup.${stayDays > 1 ? "days" : "day"
                          }`,
                          { count: stayDays }
                        )
                        : "-"}
                    </StyledTableCell>
                    {isQuickReservation && (
                      <StyledTableCell align="center">
                        {noOfRooms}
                      </StyledTableCell>
                    )}
                    <StyledTableCell align="right">₹{subTotal}</StyledTableCell>
                  </TableRow>
                  {row?.extra_persons?.length ? (
                    <TableRow>
                      <StyledTableCell colSpan={8} sx={{ padding: 0 }}>
                        <Table size="medium">
                          <TableBody>
                            <TableRow>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                {t(
                                  `common_components.tariff_popup.extra_persons`
                                )}
                              </StyledTableCell>
                            </TableRow>
                            {row.extra_persons.map((per, perInd) => {
                              total += per.netRent;
                              return (
                                <TableRow key={perInd}>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell>
                                    {perInd + 1}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>

                                  <CollapsedTableCell
                                    sx={{
                                      whiteSpace: "nowrap",
                                      position: "relative",
                                      left: { xs: 35, sm: 60, md: 60 },
                                    }}
                                    align="right"
                                  >
                                    ₹{per.addon_base_price}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell
                                    sx={{
                                      position: "relative",
                                      right: { xs: 10, sm: -10 },
                                    }}
                                    align="right"
                                  >
                                    ₹{Number(per.taxAmount).toFixed(2)} ({getTotalTaxRate(per)}%)
                                  </CollapsedTableCell>
                                  <CollapsedTableCell
                                    sx={{
                                      position: "relative",
                                      right: { xs: 10, sm: -5 },
                                    }}
                                    align="right"
                                  >
                                    ₹
                                    {Number(per.netRent) / Number(per.stayDays)}
                                    {/* {(Number(per.addon_base_price) + Number(per.taxAmount))?.toFixed(2)} */}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell align="center">
                                    {per?.stayDays
                                      ? t(
                                        `common_components.tariff_popup.${per.stayDays > 1 ? "days" : "day"
                                        }`,
                                        { count: per.stayDays }
                                      )
                                      : "-"}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell
                                    // align={isSmallScreen ? "center" : "right "}
                                    align="right"
                                  >
                                    ₹{per.netRent}
                                  </CollapsedTableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </StyledTableCell>
                    </TableRow>
                  ) : (
                    ""
                  )}
                  {row?.charge_postings?.length ? (
                    <TableRow>
                      <StyledTableCell colSpan={8} sx={{ padding: 0 }}>
                        <Table size="medium">
                          <TableBody>
                            <TableRow>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Charge Posting
                                {/* {t(
                                  `common_components.tariff_popup.charge_postings`
                                )} */}
                              </StyledTableCell>

                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                S.No
                              </StyledTableCell>
                              <CollapsedTableCell></CollapsedTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Outlet
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Revenue
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Description
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              ></StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Total
                              </StyledTableCell>
                            </TableRow>

                            {row.charge_postings.map((charge, chargeInd) => {
                              total += charge.total; // accumulate total charges
                              return (
                                <TableRow key={chargeInd}>
                                  {" "}
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell align="center">
                                    {chargeInd + 1}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell>
                                    {charge.outlet_name}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell>
                                    {charge.revenue_type_name}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell>
                                    {charge.description}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell align="center">
                                    ₹{charge.total}
                                  </CollapsedTableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </StyledTableCell>
                    </TableRow>
                  ) : (
                    ""
                  )}
                  {row?.guest_disbursement?.length ? (
                    <TableRow>
                      <StyledTableCell colSpan={8} sx={{ padding: 0 }}>
                        <Table size="medium">
                          <TableBody>
                            <TableRow>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Guest Disbursement
                              </StyledTableCell>

                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                S.No
                              </StyledTableCell>
                              <CollapsedTableCell></CollapsedTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Guest Disbursement No
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Type
                              </StyledTableCell>
                              <CollapsedTableCell></CollapsedTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              ></StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Amount
                              </StyledTableCell>
                            </TableRow>

                            {row.guest_disbursement.map((gd, gdInd) => {
                              total += gd.amount; // accumulate guest disbursement total  amounts
                              return (
                                <TableRow key={gd.guest_disbursement_id}>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell align="center">
                                    {gdInd + 1}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell>
                                    {gd.occupancy_charge_number}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell>
                                    {gd.disbursement_type_name}
                                  </CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell align="center">
                                    ₹{gd.amount}
                                  </CollapsedTableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </StyledTableCell>
                    </TableRow>
                  ) : (
                    ""
                  )}
                  {row?.paid_out?.length ? (
                    <TableRow>
                      <StyledTableCell colSpan={8} sx={{ padding: 0 }}>
                        <Table size="medium">
                          <TableBody>
                            <TableRow>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Paid Out
                              </StyledTableCell>

                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                S.No
                              </StyledTableCell>

                              <CollapsedTableCell></CollapsedTableCell>

                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Paid Out No
                              </StyledTableCell>

                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Type
                              </StyledTableCell>

                              <CollapsedTableCell></CollapsedTableCell>
                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              ></StyledTableCell>

                              <StyledTableCell
                                sx={{
                                  border: 0,
                                  padding: "0.5% 0 0 2%",
                                  color: "#DEA829",
                                }}
                              >
                                Amount
                              </StyledTableCell>
                            </TableRow>

                            {row.paid_out.map((po, poInd) => {
                              total -= po.amount;
                              return (
                                <TableRow key={po.occupancy_charge_id}>
                                  <CollapsedTableCell></CollapsedTableCell>

                                  <CollapsedTableCell align="center">
                                    {poInd + 1}
                                  </CollapsedTableCell>

                                  <CollapsedTableCell></CollapsedTableCell>

                                  <CollapsedTableCell>
                                    {po.occupancy_charge_number}
                                  </CollapsedTableCell>

                                  <CollapsedTableCell>
                                    {po.paid_out_type_name}
                                  </CollapsedTableCell>

                                  <CollapsedTableCell></CollapsedTableCell>
                                  <CollapsedTableCell></CollapsedTableCell>

                                  <CollapsedTableCell align="center">
                                    - ₹{po.amount}
                                  </CollapsedTableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </StyledTableCell>
                    </TableRow>
                  ) : (
                    ""
                  )}
                </Fragment>
              );
            })
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={10}
                align="center"
                sx={{ padding: "2%", color: "#bab9ba" }}
              >
                {t("pages.home_page.todays_activity.no_data_found")}
              </StyledTableCell>
            </TableRow>
          )}

          {appliedCoupon && safeCouponDiscountAmount > 0 && (
            <TableRow>
              <StyledTableCell
                colSpan={7}
                align="right"
                sx={{
                  color: "#28a745",
                  fontWeight: 600,
                  fontSize: {
                    xs: "2.397vw !important",
                    sm: "1.472vw !important",
                    md: "0.972vw !important",
                  },
                }}
              >
                Coupon: {appliedCoupon.coupon_name} ({appliedCoupon.coupon_code})
              </StyledTableCell>
              <StyledTableCell
                align="right"
                sx={{
                  color: "#28a745",
                  fontWeight: 600,
                  fontSize: {
                    xs: "3.797vw !important",
                    sm: "1.972vw !important",
                    md: "0.972vw !important",
                  },
                }}
              >
                - ₹{calculateTotal(Math.min(total, safeCouponDiscountAmount))}
              </StyledTableCell>
            </TableRow>
          )}

          <TableRow>
            <StyledTableCell
              colSpan={7}
              align="right"
              sx={{
                ...getGradientTextStyle(palette),
                fontSize: {
                  xs: "2.397vw !important",
                  sm: "1.472vw !important",
                  md: "0.972vw !important",
                },
              }}
            >
              {t("common_components.payments.total")}
            </StyledTableCell>
            <StyledTableCell
              align="right"
              sx={{
                fontSize: {
                  xs: "3.797vw !important",
                  sm: "1.972vw !important",
                  md: "0.972vw !important",
                },
                ...getGradientTextStyle(palette),
              }}
            >
              ₹{calculateTotal(Math.max(0, total - safeCouponDiscountAmount))}
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Popover>
  );
};

export default TariffPopup;
